module.exports = __webpack_public_path__ + "img/Y4.6d21e9e9.png";